import { preFillApplication } from '@/adapter/applicationLoader';
import { useApplication } from '@/hooks/useApplication';
import { useDialogs } from '@/hooks/useDialogs';
import { useMetadata } from '@/hooks/useMetadata';
import { APPLICATION_FORMAT, emptyApplication } from '@/util/application';
import { migrateApplication } from '@/util/migration/migration';
import { useEffect } from 'react';

const RestoredApplication = ({ children }: { children: React.ReactNode }) => {
  const { application, setApplication } = useApplication();
  const { metadata } = useMetadata();
  const { showTable, showError } = useDialogs();
  const isCurrentFormat = application.format === APPLICATION_FORMAT;

  useEffect(() => {
    if (isCurrentFormat) return;

    try {
      const migrated = migrateApplication({ ...application }, metadata, showTable);
      setApplication(preFillApplication(migrated, metadata), true);
    } catch (error) {
      // Keeping it would leave every component below waiting for a format that is never going to arrive.
      setApplication(emptyApplication, true);
      showError({
        title: 'The restored project was closed',
        message: error instanceof Error ? error.message : 'The stored project could not be migrated.',
        stacktrace: error
      });
    }
  }, [isCurrentFormat]);

  return isCurrentFormat ? children : undefined;
};

export default RestoredApplication;
